import { Component, computed, input } from '@angular/core';

import { IRankedRobot } from '../../domain/ranking';
import { CobotCardComponent } from '../cobot-card/cobot-card.component';

export const COLLAPSED_RESULT_COUNT = 3;

@Component({
    selector: 'robot-selector-result-list',
    templateUrl: './result-list.component.html',
    styleUrl: './result-list.component.scss',
    imports: [CobotCardComponent],
    host: {
        'class': 'robot-result-list',
    },
})
export class ResultListComponent {
    readonly results = input.required<readonly IRankedRobot[]>();
    readonly bestMatchLabel = input.required<string>();
    readonly viewProductLabel = input.required<string>();

    readonly isExpanded = input(false);

    readonly markBestMatch = input(true);

    readonly visibleResults = computed(() =>
        this.isExpanded() ? this.results() : this.results().slice(0, COLLAPSED_RESULT_COUNT)
    );
}
